const timeAgo = (dateStr) => {
  if (!dateStr) return "\u2014";
  // SQLite CURRENT_TIMESTAMP stores UTC without timezone suffix —
  // append Z so JS Date parses it as UTC, not local time.
  const normalized = dateStr.endsWith("Z") || dateStr.includes("+") || dateStr.includes("T") && dateStr.match(/[+-]\d{2}:/)
    ? dateStr
    : dateStr + "Z";
  const diff = Date.now() - new Date(normalized).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
};

export default timeAgo;
